__turbopack_context__.v({
  "externalIcon": "U5i1fW_externalIcon",
  "externalText": "U5i1fW_externalText",
  "link": "U5i1fW_link",
  "linkInherit": "U5i1fW_linkInherit",
  "linkLg": "U5i1fW_linkLg",
  "linkMd": "U5i1fW_linkMd",
  "linkSm": "U5i1fW_linkSm",
  "srOnly": "U5i1fW_srOnly",
  "textLink": "U5i1fW_textLink",
  "underlineHover": "U5i1fW_underlineHover",
});
